import { useEffect, useState } from 'react';
import { fetchUserInfo } from '../api/loginApi';

export function useCheckAuth() {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    fetchUserInfo()
      .then((data) => {
        if (data.success) {
          setIsLoggedIn(true);
          setIsLoading(false);
          return;
        }
      })
      .catch(() => {
        setIsLoggedIn(false);
        setIsLoading(false);
      });
  }, []);

  return { isLoggedIn, isLoading };
}
